import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  de: {
    translation: {
      // Auth
      login: 'Anmelden',
      register: 'Registrieren',
      email: 'E-Mail',
      password: 'Passwort',
      companyName: 'Firmenname',
      contactName: 'Ansprechpartner',
      phone: 'Telefon',
      address: 'Adresse',
      city: 'Stadt',
      postalCode: 'Postleitzahl',
      // Navigation
      home: 'Startseite',
      shop: 'Shop',
      favorites: 'Favoriten',
      cart: 'Warenkorb',
      orders: 'Bestellungen',
      profile: 'Profil',
      admin: 'Admin',
      logout: 'Abmelden',
      // Product
      products: 'Produkte',
      search: 'Suchen',
      price: 'Preis',
      priceNet: 'Netto',
      priceGross: 'Brutto',
      artNr: 'Art.-Nr.',
      addToCart: 'In den Warenkorb',
      addToFavorites: 'Zu Favoriten hinzufügen',
      removeFromFavorites: 'Aus Favoriten entfernen',
      // Cart
      subtotal: 'Zwischensumme',
      shipping: 'Versandkosten',
      total: 'Gesamt',
      freeShipping: 'Versandkostenfrei',
      untilFreeShipping: 'Noch {{amount}} bis versandkostenfrei',
      checkout: 'Zur Kasse',
      // Order
      orderNow: 'Jetzt bestellen',
      paymentMethod: 'Zahlungsart',
      onlinePayment: 'Online-Zahlung',
      cashOnDelivery: 'Barzahlung bei Lieferung',
      orderNotes: 'Anmerkungen zur Bestellung',
      placeOrder: 'Bestellung abschicken',
      // Status
      eingegangen: 'Eingegangen',
      in_bearbeitung: 'In Bearbeitung',
      versendet: 'Versendet',
      geliefert: 'Geliefert',
      // Categories
      haarschneidemaschinen: 'Haarschneidemaschinen',
      rasierklingen: 'Rasierklingen',
      barberbedarf: 'Barberbedarf',
      foehns: 'Föhns',
      haarwachs: 'Haarwachs & Styling',
      zubehoer: 'Zubehör',
      // Profile
      editProfile: 'Profil bearbeiten',
      changePassword: 'Passwort ändern',
      currentPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort',
      confirmPassword: 'Passwort bestätigen',
      save: 'Speichern',
      cancel: 'Abbrechen',
      orderHistory: 'Bestellhistorie',
      savedProducts: 'Gespeicherte Produkte',
      noFavorites: 'Keine Favoriten vorhanden',
      goToShop: 'Zum Shop',
      // Common
      loading: 'Wird geladen...',
      error: 'Fehler',
      success: 'Erfolgreich'
    }
  },
  tr: {
    translation: {
      login: 'Giriş Yap',
      register: 'Kayıt Ol',
      email: 'E-posta',
      password: 'Şifre',
      companyName: 'Şirket Adı',
      contactName: 'İletişim Kişisi',
      phone: 'Telefon',
      address: 'Adres',
      city: 'Şehir',
      postalCode: 'Posta Kodu',
      home: 'Ana Sayfa',
      shop: 'Mağaza',
      favorites: 'Favoriler',
      cart: 'Sepet',
      orders: 'Siparişler',
      profile: 'Profil',
      admin: 'Yönetici',
      logout: 'Çıkış',
      products: 'Ürünler',
      search: 'Ara',
      price: 'Fiyat',
      addToCart: 'Sepete Ekle',
      addToFavorites: 'Favorilere Ekle',
      removeFromFavorites: 'Favorilerden Çıkar',
      subtotal: 'Ara Toplam',
      shipping: 'Kargo',
      total: 'Toplam',
      freeShipping: 'Ücretsiz Kargo',
      untilFreeShipping: 'Ücretsiz kargo için {{amount}} kaldı',
      checkout: 'Ödeme',
      orderNow: 'Şimdi Sipariş Ver',
      paymentMethod: 'Ödeme Yöntemi',
      onlinePayment: 'Online Ödeme',
      cashOnDelivery: 'Kapıda Ödeme',
      orderNotes: 'Sipariş Notları',
      placeOrder: 'Siparişi Tamamla',
      eingegangen: 'Alındı',
      in_bearbeitung: 'İşlemde',
      versendet: 'Gönderildi',
      geliefert: 'Teslim Edildi',
      haarschneidemaschinen: 'Saç Kesme Makineleri',
      rasierklingen: 'Tıraş Bıçakları',
      barberbedarf: 'Berber Malzemeleri',
      foehns: 'Föhnler',
      haarwachs: 'Saç Wax & Styling',
      zubehoer: 'Aksesuarlar'
    }
  },
  ar: {
    translation: {
      login: 'تسجيل الدخول',
      register: 'التسجيل',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      companyName: 'اسم الشركة',
      contactName: 'الشخص المسؤول',
      phone: 'الهاتف',
      address: 'العنوان',
      city: 'المدينة',
      postalCode: 'الرمز البريدي',
      home: 'الرئيسية',
      shop: 'المتجر',
      favorites: 'المفضلة',
      cart: 'السلة',
      orders: 'الطلبات',
      profile: 'الملف الشخصي',
      admin: 'المسؤول',
      logout: 'تسجيل الخروج',
      products: 'المنتجات',
      search: 'بحث',
      price: 'السعر',
      addToCart: 'أضف إلى السلة',
      addToFavorites: 'أضف إلى المفضلة',
      removeFromFavorites: 'إزالة من المفضلة',
      subtotal: 'المجموع الفرعي',
      shipping: 'الشحن',
      total: 'الإجمالي',
      freeShipping: 'شحن مجاني',
      untilFreeShipping: 'متبقي {{amount}} للشحن المجاني',
      checkout: 'الدفع',
      orderNow: 'اطلب الآن',
      paymentMethod: 'طريقة الدفع',
      onlinePayment: 'الدفع عبر الإنترنت',
      cashOnDelivery: 'الدفع عند الاستلام',
      orderNotes: 'ملاحظات الطلب',
      placeOrder: 'تأكيد الطلب',
      eingegangen: 'تم الاستلام',
      in_bearbeitung: 'قيد المعالجة',
      versendet: 'تم الإرسال',
      geliefert: 'تم التسليم',
      haarschneidemaschinen: 'ماكينات قص الشعر',
      rasierklingen: 'شفرات الحلاقة',
      barberbedarf: 'مستلزمات الحلاقة',
      foehns: 'مجففات الشعر',
      haarwachs: 'واكس الشعر والتصفيف',
      zubehoer: 'الملحقات'
    }
  },
  en: {
    translation: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      companyName: 'Company Name',
      contactName: 'Contact Name',
      phone: 'Phone',
      address: 'Address',
      city: 'City',
      postalCode: 'Postal Code',
      home: 'Home',
      shop: 'Shop',
      favorites: 'Favorites',
      cart: 'Cart',
      orders: 'Orders',
      profile: 'Profile',
      admin: 'Admin',
      logout: 'Logout',
      products: 'Products',
      search: 'Search',
      price: 'Price',
      addToCart: 'Add to Cart',
      addToFavorites: 'Add to Favorites',
      removeFromFavorites: 'Remove from Favorites',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      total: 'Total',
      freeShipping: 'Free Shipping',
      untilFreeShipping: '{{amount}} until free shipping',
      checkout: 'Checkout',
      orderNow: 'Order Now',
      paymentMethod: 'Payment Method',
      onlinePayment: 'Online Payment',
      cashOnDelivery: 'Cash on Delivery',
      orderNotes: 'Order Notes',
      placeOrder: 'Place Order',
      eingegangen: 'Received',
      in_bearbeitung: 'Processing',
      versendet: 'Shipped',
      geliefert: 'Delivered',
      haarschneidemaschinen: 'Hair Clippers',
      rasierklingen: 'Razor Blades',
      barberbedarf: 'Barber Supplies',
      foehns: 'Hair Dryers',
      haarwachs: 'Hair Wax & Styling',
      zubehoer: 'Accessories'
    }
  },
  it: {
    translation: {
      login: 'Accedi',
      register: 'Registrati',
      email: 'Email',
      password: 'Password',
      companyName: 'Nome Azienda',
      contactName: 'Nome Contatto',
      phone: 'Telefono',
      address: 'Indirizzo',
      city: 'Città',
      postalCode: 'CAP',
      home: 'Home',
      shop: 'Negozio',
      favorites: 'Preferiti',
      cart: 'Carrello',
      orders: 'Ordini',
      profile: 'Profilo',
      admin: 'Admin',
      logout: 'Esci',
      products: 'Prodotti',
      search: 'Cerca',
      price: 'Prezzo',
      addToCart: 'Aggiungi al Carrello',
      addToFavorites: 'Aggiungi ai Preferiti',
      removeFromFavorites: 'Rimuovi dai Preferiti',
      subtotal: 'Subtotale',
      shipping: 'Spedizione',
      total: 'Totale',
      freeShipping: 'Spedizione Gratuita',
      untilFreeShipping: '{{amount}} per spedizione gratuita',
      checkout: 'Checkout',
      orderNow: 'Ordina Ora',
      paymentMethod: 'Metodo di Pagamento',
      onlinePayment: 'Pagamento Online',
      cashOnDelivery: 'Contrassegno',
      orderNotes: 'Note Ordine',
      placeOrder: 'Conferma Ordine',
      eingegangen: 'Ricevuto',
      in_bearbeitung: 'In Lavorazione',
      versendet: 'Spedito',
      geliefert: 'Consegnato',
      haarschneidemaschinen: 'Tagliacapelli',
      rasierklingen: 'Lame da Barba',
      barberbedarf: 'Articoli da Barbiere',
      foehns: 'Asciugacapelli',
      haarwachs: 'Cera per Capelli & Styling',
      zubehoer: 'Accessori'
    }
  },
  fr: {
    translation: {
      login: 'Se connecter',
      register: 'S\'inscrire',
      email: 'Email',
      password: 'Mot de passe',
      companyName: 'Nom de l\'entreprise',
      contactName: 'Nom du contact',
      phone: 'Téléphone',
      address: 'Adresse',
      city: 'Ville',
      postalCode: 'Code postal',
      home: 'Accueil',
      shop: 'Boutique',
      favorites: 'Favoris',
      cart: 'Panier',
      orders: 'Commandes',
      profile: 'Profil',
      admin: 'Admin',
      logout: 'Déconnexion',
      products: 'Produits',
      search: 'Rechercher',
      price: 'Prix',
      addToCart: 'Ajouter au Panier',
      addToFavorites: 'Ajouter aux Favoris',
      removeFromFavorites: 'Retirer des Favoris',
      subtotal: 'Sous-total',
      shipping: 'Livraison',
      total: 'Total',
      freeShipping: 'Livraison Gratuite',
      untilFreeShipping: '{{amount}} pour livraison gratuite',
      checkout: 'Payer',
      orderNow: 'Commander maintenant',
      paymentMethod: 'Mode de paiement',
      onlinePayment: 'Paiement en ligne',
      cashOnDelivery: 'Paiement à la livraison',
      orderNotes: 'Notes de commande',
      placeOrder: 'Confirmer la commande',
      eingegangen: 'Reçu',
      in_bearbeitung: 'En cours',
      versendet: 'Expédié',
      geliefert: 'Livré',
      haarschneidemaschinen: 'Tondeuses',
      rasierklingen: 'Lames de rasoir',
      barberbedarf: 'Fournitures de barbier',
      foehns: 'Sèche-cheveux',
      haarwachs: 'Cire & Coiffage',
      zubehoer: 'Accessoires'
    }
  },
  es: {
    translation: {
      login: 'Iniciar sesión',
      register: 'Registrarse',
      email: 'Correo electrónico',
      password: 'Contraseña',
      companyName: 'Nombre de la empresa',
      contactName: 'Nombre de contacto',
      phone: 'Teléfono',
      address: 'Dirección',
      city: 'Ciudad',
      postalCode: 'Código postal',
      home: 'Inicio',
      shop: 'Tienda',
      favorites: 'Favoritos',
      cart: 'Carrito',
      orders: 'Pedidos',
      profile: 'Perfil',
      admin: 'Admin',
      logout: 'Cerrar sesión',
      products: 'Productos',
      search: 'Buscar',
      price: 'Precio',
      addToCart: 'Añadir al carrito',
      addToFavorites: 'Añadir a favoritos',
      removeFromFavorites: 'Eliminar de favoritos',
      subtotal: 'Subtotal',
      shipping: 'Envío',
      total: 'Total',
      freeShipping: 'Envío Gratis',
      untilFreeShipping: '{{amount}} para envío gratis',
      checkout: 'Pagar',
      orderNow: 'Pedir ahora',
      paymentMethod: 'Método de pago',
      onlinePayment: 'Pago en línea',
      cashOnDelivery: 'Pago contra reembolso',
      orderNotes: 'Notas del pedido',
      placeOrder: 'Confirmar pedido',
      eingegangen: 'Recibido',
      in_bearbeitung: 'En proceso',
      versendet: 'Enviado',
      geliefert: 'Entregado',
      haarschneidemaschinen: 'Cortapelos',
      rasierklingen: 'Hojas de afeitar',
      barberbedarf: 'Suministros de barbería',
      foehns: 'Secadores de pelo',
      haarwachs: 'Cera para el cabello y estilizado',
      zubehoer: 'Accesorios'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;